import { render, staticRenderFns } from "./ProductsListWithOutStockIRR.vue?vue&type=template&id=694a7b64&"
import script from "./ProductsListWithOutStockIRR.vue?vue&type=script&lang=js&"
export * from "./ProductsListWithOutStockIRR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports